// extracted by mini-css-extract-plugin
export default {"twitter-picker":"styles-module__twitter-picker__src-labstep-web-prosemirror-components-Toolbar-ColorPicker-_ofShD"};